<template>
  <v-dialog scrollable persistent v-model="config.status.active" max-width="600">
    <PostRecorder
      v-if="config.type === 'post'"
      ref="post"
      :closer="true"
      @done="close"
      @close="close"
    />
    <CreditRecorder
      v-else-if="config.type === 'credit'"
      ref="credit"
      :close="true"
      @done="close"
      @close="close"
    />
    <TutorRecorder
      v-else-if="config.type === 'tutor'"
      ref="tutor"
      :close="true"
      @done="close"
      @close="close"
    />
  </v-dialog>
</template>

<script>
import PostRecorder from '@/components/recorder/post'
import CreditRecorder from '@/components/recorder/credit'
import TutorRecorder from '@/components/recorder/tutor'

export default {
  name: 'recordsInsertModal',
  components: {
    PostRecorder,
    CreditRecorder,
    TutorRecorder
  },
  data () {
    return {
      config: {
        type: 'post',
        status: {
          active: false
        }
      }
    }
  },
  methods: {
    open: function (req) {
      const { type } = req
      this.$set(this.config, 'type', type)
      this.$nextTick(() => {
        this.$set(this.config.status, 'active', true)
        this.$nextTick(() => {
          this.$refs[this.config.type].init()
        })
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  }
}
</script>